export enum LAYER_NAME {
    BG = "BG",
    GAME = "GAME",
    UI = "UI"
}

export const GAME_PARAMS = {
    zombCount: 0,
    isLayerDefined: false,
    highScore: 0
}